/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { RouteObject } from 'react-router'
import TransactionListPage from './TransactionListPage'
import TransactionFormPage from './TransactionFormPage'

export const expenseRoutes: RouteObject[] = [
  {
    index: true,
    element: <TransactionListPage expense />
  },
  {
    path: 'create',
    element: <TransactionFormPage expense />
  },
  {
    path: ':id/*',
    children: [
      {
        path: 'edit',
        element: <TransactionFormPage expense />
      }
    ]
  }
]
